<template>
  <div>
    <h-loading v-if="isLoading" />

    <div v-if="showInvoices">
      <div v-for="item in adminHostPendingInvoices" :key="item.id" class="pa-5">
        <p class="title">{{ item.month }}</p>

        <AdminPaymentsFortnight
          :payments="item.payments_first_half"
          :title="$t('hausefulInvoices.firstHalf')"
        />

        <AdminPaymentsFortnight
          :payments="item.payments_second_half"
          :title="$t('hausefulInvoices.secondHalf')"
        />
      </div>
    </div>

    <div v-if="showEmptyState">
      <p class="text-center grey--text my-5">
        {{ $t('hausefulInvoices.messages.noPendingInvoices') }}
      </p>
    </div>

    <v-divider />

    <h-pagination
      :fetch="fetchAdminHostPendingInvoices"
      :requireOrderByFilter="false"
      :noBorders="true"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import AdminPendingInvoicesFilters from './filters/AdminPendingInvoicesFilters'
import AdminPaymentsFortnight from './fragments/AdminPaymentsFortnight'

export default {
  name: 'AdminPendingInvoices',

  components: {
    AdminPendingInvoicesFilters,
    AdminPaymentsFortnight,
  },

  computed: {
    ...mapGetters(['adminHostPendingInvoices', 'isLoading']),

    showInvoices() {
      return !this.isLoading && this.adminHostPendingInvoices?.length >= 1
    },

    showEmptyState() {
      return !this.isLoading && this.adminHostPendingInvoices?.length <= 0
    },
  },

  methods: {
    ...mapActions(['fetchAdminHostPendingInvoices']),
    ...mapMutations(['setIsDrawerOpen']),

    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item]
    },

    showHostInvoices() {
      this.setIsDrawerOpen(true)
    },
  },
}
</script>
